
import React from "react";
import '../style/Obverify.css';

function BranchOption() {
  
    const goPerson = () => (window.location.href = `/AuthBrPrivate`);
     const goNew = () => (window.location.href = `/AuthPr`);
    const goJoint = () => (window.location.href = `/AuthBrJoint`);
    const goPlc = () => (window.location.href = `/AuthBrPlc`);
    return (
        <div className="app-container">
            <h2 className="title"> Welcome to Oromia Bank's Customer Identity Verification Portal</h2>
            <div className="button-group">
                <button className="login-button" onClick={goPerson}>
                   Individual Account
                </button>
                <button className="login-button" onClick={goJoint}>
                     Joint Account
                </button>
                <button className="login-button" onClick={goPlc}>
                     Corporate Account
                </button>
                 <button className="login-button" onClick={goNew}>
                   New Account
                </button>
            </div>
        </div>
    );
}

export default BranchOption;